const ShimmerLoader = () => (
  <div className="shimmer-container" style={{minHeight: '100vh', background: '#fff'}}>
    <div className="pdp-container container pl0 pr0">
      <div className="row g-4">
        <div className="col-sm-7 col-lg-8 pr20">
          <div className="shimmer-block" style={{height: '60px', marginBottom: '20px'}}></div>
          <div className="shimmer-block" style={{height: '400px', marginBottom: '20px'}}></div>
          <div className="shimmer-block" style={{height: '100px', marginBottom: '20px'}}></div>
          <div className="shimmer-block" style={{height: '200px'}}></div>
        </div>
        <div className="col-sm-5 col-lg-4 pr0">
          <div className="shimmer-block" style={{height: '300px', marginBottom: '20px'}}></div>
          <div className="shimmer-block" style={{height: '150px'}}></div>
        </div>
      </div>
    </div>
    <style>{`
      .shimmer-container {
        padding: 16px 0 10px;
        margin-top: 110px;
        opacity: 1;
        transition: none;
      }
      .shimmer-block {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 4px;
      }
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      .container { max-width: 1200px; margin: 0 auto; padding: 0 15px; }
      .row { display: flex; flex-wrap: wrap; margin: 0; }
      .col-sm-7, .col-lg-8 { flex: 0 0 66.666667%; max-width: 66.666667%; padding: 0 15px; }
      .col-sm-5, .col-lg-4 { flex: 0 0 33.333333%; max-width: 33.333333%; padding: 0 15px; }
      .pr20 { padding-right: 20px; }
      .pl0 { padding-left: 0; }
      .pr0 { padding-right: 0; }
    `}</style>
  </div>
);

export default ShimmerLoader;